import { defineStore } from 'pinia'
import { ref } from 'vue'
import subscriptionApi from '@/api/subscription'

// Source of truth for "institute-sponsored" members. The backend owns this logic
// and exposes it via GET /subscriptions/my -> managedByInstitute. When true, the
// member has a free top-tier plan and cannot subscribe/upgrade/downgrade/cancel.
export const useSubscriptionStore = defineStore('subscription', () => {
  const managedByInstitute = ref(false)
  const loaded = ref(false)

  async function fetchMy(force = false) {
    if (loaded.value && !force) return
    try {
      const res = await subscriptionApi.getMy()
      const data = res?.data?.data ?? {}
      managedByInstitute.value = data.managedByInstitute === true
      loaded.value = true
    } catch {
      // Keep defaults (treat as a normal self-paying user) on any error.
    }
  }

  function reset() {
    managedByInstitute.value = false
    loaded.value = false
  }

  return { managedByInstitute, loaded, fetchMy, reset }
})
